import type { z } from 'zod';
import type { InspectionEvaluationRsModel } from '../projects/_models/project';

export const checkEnabledInputReflectedAmount = (
  reflectionStatusBasedOnOpinionAction:
    | NonNullable<
        z.infer<
          typeof InspectionEvaluationRsModel
        >['reflectionStatusBasedOnOpinion']
      >['action']
    | undefined,
) => {
  return (
    reflectionStatusBasedOnOpinionAction === 'abolition' ||
    reflectionStatusBasedOnOpinionAction === 'reduction'
  );
};
